import { render } from "./어린이회원가입_step2.vue?vue&type=template&id=2c97cc72"
import script from "./어린이회원가입_step2.vue?vue&type=script&lang=js"
export * from "./어린이회원가입_step2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__